import Navbar from "../../../components/Navbar/Navbar";
import PrescriptionList from "../components/PrescriptionList/PrescriptionList";

export default function PrescriptionListPage() {
    return (
        <>
            <Navbar title="Prescriptions" />
            <div className="page">
                <PrescriptionList />
            </div>
        </>
    );
}
